import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileComingSoonPage.css';

export default function MobileComingSoonPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mobile-coming-soon-page">
      <div className="coming-soon-content">
        <div className="scout-badge-large">
          <div className="scout-glow"></div>
          <img
            src="/scout_images/Scout_Thumbsup.png"
            alt="Scout the DocuHounds mascot"
            className="scout-image"
          />
        </div>

        <h1 className="coming-soon-title">Mobile login coming soon</h1>
        <p className="coming-soon-subtitle">
          For now, use DocuHounds in your mobile browser or on desktop while Scout finishes the native app.
        </p>

        <div className="coming-soon-pill">
          <span className="pill-label">Built by students. Powered by AI.</span>
        </div>

        <button
          className="btn-primary"
          type="button"
          onClick={() => navigate('/m')}
        >
          Back to Scout's homepage
        </button>

        <button
          className="btn-secondary"
          type="button"
          onClick={() => navigate('/m')}
        >
          Continue browsing
        </button>
      </div>
    </div>
  );
}
